import { Currency } from '@core/constants/data-types.constants';
import { Product } from './product.model';

export interface Increase {
  percentage: number;
  description: string;
  currency: Currency;
}

export function getProductAvailableIncreases(product: Product, currency: Currency) {
  if (product.allowedIncreases && product.allowedIncreases.length > 0) {
    return product.allowedIncreases.filter(increase => {
      return increase.currency === currency;
    });
  }
  return [];
}
